// extracted by mini-css-extract-plugin
export default {"mainpart":"buttonordbox_mainpart__cepDo"};